import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {ExpirationTypes, RefundTypes} from "../../../types/transaction/transaction.types";
import {getMemberRefundDetail} from "../../../api/transaction/refundApi";
import {formatDateTime, setComma} from "../../../utils/format";
import {getMemberExpiredDetail} from "../../../api/transaction/expiredApi";

const ExpiredDetailPage = () => {

    const {id} = useParams<{ id: string }>();

    const [expiredData, setExpiredData] = useState<ExpirationTypes>();
    const [loading, setLoading] = useState(true);


    const getExpiredData = async () => {
        if (!id) return;
        try {
            setLoading(true);
            const result = await getMemberExpiredDetail(id);
            if (result.data.code == "00") {
                setExpiredData(result.data.data);
            }
        } catch (err) {
            console.error('기간만료 상세 에러:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getExpiredData();
    }, [])

    return (
        <>
            {(!loading && expiredData) && (() => {

                return (
                    <div>

                        <main className="container type_gray">
                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">기본 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">만료금액</span>
                                            <span className="txt">{setComma(expiredData.originalAmount)} 원</span>
                                        </li>
                                        <li>
                                            <span className="tit">만료일자</span>
                                            <span className="txt">{expiredData.expireDate}</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래상태</span>
                                            <span className="status finish">기간만료</span>
                                        </li>
                                    </ul>
                                </div>
                            </section>

                            <section className="bg-white">
                                <div className="inner-box">
                                    <h3 className="dot-tit">WINPAY 정보</h3>
                                    <ul className="detail-info">
                                        <li>
                                            <span className="tit">거래 전 잔액</span>
                                            <span className="txt">{setComma(expiredData.balanceBefore)}원</span>
                                        </li>
                                        <li>
                                            <span className="tit">거래 후 잔액</span>
                                            <span className="txt">{setComma(expiredData.balanceAfter)}원</span>
                                        </li>

                                    </ul>
                                </div>
                            </section>

                            <section>
                                <div className="inner">
                                    <h5 className="point-tit">WINPAY 기간만료 안내</h5>
                                    <ul className="guidF-list">
                                        <li>WINPAY는 마지막 충전일로부터 5년간 사용할 수 있습니다.</li>
                                        <li>유효기간 경과 시 자동 소멸되며 환불이 불가합니다.</li>
                                        <li>관련 법령에 따라 5년간 거래 내역은 보관됩니다.</li>
                                    </ul>
                                </div>
                            </section>
                        </main>
                    </div>
                );
            })
            ()}
        </>


    );
};

export default ExpiredDetailPage;

